import _ from 'lodash'
import cx from 'classnames'
import React, { PureComponent } from 'react'
import T from 'prop-types'
import IT from 'react-immutable-proptypes'
import {
  TYPES,
  ENUM_STYLES,
  FORM_STYLES,
  DEFAULT_FORM_STYLE
} from '../types'
import Schema from '../Schema'
import {
  TextInput,
  DropdownMenu,
  // MenuItem,
  TextOverflow,
  TypeaheadInput,
  TagInput,
  OnOffSwitch
} from 'react-base'
import {
  TextareaInput,
  ListInput,
  IpListInput,
  DomainListInput,
  UrlListInput,
  FileHashListInput
} from 'pw-drafty'
import {
  fromJS,
  Set,
  List,
  Iterable
} from 'immutable'
import {
  SCHEMA_ITEM_SHAPE,
  FIELD_OPTIONS_SHAPE,
  CUSTOM_INPUTS_SHAPE,
  SCHEMA_SHAPE
} from '../shapes'

const POST_BLUR_DELAY = 300 //ms

// const FILTERABLE_DROPDOWN_OPTION_COUNT = 10 // If ENUM options greater than this, options will be filterable

// const prepareOptions = (options/*, context*/) => {
//   // Support async option retrieval functions
//   // TODO args for the options() function?
//   // return (typeof options === 'function' ? options() : options).map(option => {
//   return options.map(option => {
//     return {
//       id: option.id || option,
//       name: option.display || option,
//       icon: option.icon || null,
//       count: option.count || null,
//       headingText: option.headingText || null,
//       readOnlyOption: option.readOnlyOption || false
//     }
//   })
// }

const DEFAULT_PREFIX_ICONS = {
  BOOL: null,
  INT: null,
  FLOAT: null,
  STRING: null,
  STRING_LONG: null,
  ENUM: null, //'check-menu',
  TAGS: 'tag',
  BYTES: null,
  BYTES_PER_SEC: null,
  DAY: 'calendar',
  TIME: 'clock',
  DATETIME: 'calendar',
  DURATION_MS: 'clock',

  SUBNET: null,
  IP: null,
  IP_V4: null,
  IP_V6: null,
  MAC_ADDRESS: null,
  PORT: null,
  DOMAIN: null,
  URL: null,
  HASH: null,
  HASH_MD5: null,
  HASH_SHA1: null,
  HASH_SHA256: null,
  HASH_SHA512: null
}

const BASIC_INPUT_TYPES = [
  TYPES.STRING,

  TYPES.NUMBER,
  TYPES.INT,
  TYPES.FLOAT,

  TYPES.SUBNET,
  TYPES.IP,
  TYPES.IP_V4,
  TYPES.IP_V6,
  TYPES.MAC_ADDRESS,
  TYPES.PORT,
  TYPES.DOMAIN,
  TYPES.URL,

  TYPES.HASH,
  TYPES.HASH_MD5,
  TYPES.HASH_SHA1,
  TYPES.HASH_SHA256,
  TYPES.HASH_SHA512,
]

export default class Input extends PureComponent {
  static displayName = 'Schemer.Input'

  static propTypes = {
    style: T.oneOf(Object.keys(FORM_STYLES)),
    className: T.string,
    readOnly: T.bool,
    // required: T.bool, // Also can be passed in editable. this prop supercedes that
    onFocus: T.func,
    onBlur: T.func,

    fieldName: T.string.isRequired,
    field: SCHEMA_ITEM_SHAPE,
    schema: SCHEMA_SHAPE,

    currentValue: T.any,

    onChange: T.func.isRequired,
    onValidationChange: T.func.isRequired,
    prefixIcon: T.string,
    renderDefaultPrefixIcons: T.bool,
    customInputs: CUSTOM_INPUTS_SHAPE,
    fieldOptions: FIELD_OPTIONS_SHAPE,
    showLabel: T.bool
  }


  static defaultProps = {
    // required: false,
    readOnly: true,
    style: DEFAULT_FORM_STYLE,
    renderDefaultPrefixIcons: true,
    showLabel: true
  }

  state = {
    invalidMsg: null,
    hasFocus: false,
    hasSeenFocus: false // Track if the input has seen focus at all, used for "soft" required messages
  }

  componentWillMount() {
    this.debouncedHandleInputChange = _.debounce(this.handleInputChange, 300)
    this.handleBlur = _.debounce(this._handleBlur, POST_BLUR_DELAY) // Slight delay prevents material label jittering
    this._checkValidity(this.props)
  }

  componentWillReceiveProps(nextProps) {
    // Always check validity (even when other fields are the ones changing)
    this._checkValidity(nextProps)
    // if (nextProps.currentValue !== this.props.currentValue) {
    //   this._checkValidity(nextProps)
    // }
  }

  _checkValidity = props => {
    // console.log('input checkValidity')
    const {
      // editable,
      currentValue,
      fieldName,
      field,
      schema,
      // display,
      onValidationChange,
      // required,
      // fieldOptions
    } = props || this.props
    const {
      hasSeenFocus
    } = this.state
    const display = field.get('display')
    // const {
    //   editable,
    //   display,
    //   type
    // } = field.toJS()
    // const editable
    // const {
    //   validate
    // } = editable

    // const currentValueJS = this._getCurrentValueJS(props)
    // const hasValue = Array.isArray(currentValue) ? currentValue.length > 0 : !!currentValue


    // let invalidMsg = null
    // if (validate && hasValue) { //&& currentValue (required && hasSeenFocus))) {
    //   if (type === TYPES.ENUM) {
    //     // const _options = this._getNormalizedOptions(props)
    //     const _options = schema.getFieldOptionsByName(fieldName)
    //     const _currentValAsArray = Array.isArray(currentValueJS) ? currentValueJS : [currentValueJS]
    //     invalidMsg = validate(List(_currentValAsArray), _options, editable)
    //   }
    //   else {
    //     // All other input types
    //     invalidMsg = validate(currentValueJS, editable)
    //   }

    // }
    // if (!invalidMsg && required && hasSeenFocus && !hasValue) {
    //   invalidMsg = `This field is required`
    // }

    const hasValue = Schema.hasValue(currentValue)

    const invalidMsg = schema.validateField(
      currentValue,
      field,
      hasSeenFocus // Only validate for isRequired if the field has seen focus
    )

    onValidationChange(invalidMsg, display, fieldName)
    this.setState({
      invalidMsg,
      hasValue
    })
  }

  emitChange = newValue => {
    const {
      onChange,
      fieldName
    } = this.props

    // Pass immutable constructs as value when applicable
    onChange(fromJS(newValue), fieldName)
  }

  handleInputChange = newValue => {
    this.emitChange(newValue)
  }

  _getRawCurrentValue = props => {
    const {
      currentValue
    } = props || this.props
    return currentValue // pendingValue === undefined ? initialValue : pendingValue
  }

  _getCurrentValueJS = props => {
    const {
      currentValue
    } = props || this.props
    return Iterable.isIterable(currentValue) ? currentValue.toJS() : currentValue
  }

  handleTagInputChange = tagCommit => {
    const {
      field
    } = this.props
    const valueProperty = field.get('type') === TYPES.TAGS ? 'name' : 'id'
    const getValues = vals => vals.map(v => v[valueProperty])
    const {
      create = [],
      add = [],
      remove = []
    } = _.mapValues(tagCommit, getValues)

    const currentValue = this._getCurrentValueJS()
    const newValue = Set((currentValue || [])).withMutations(v =>
      v.union(create)
      .union(add)
      .subtract(remove)
    ).toJS()

    // Always emit change, so pending tags may be applied
    this.emitChange(newValue)
  }

  handleEnumTypeaheadChange = (newValue, options) => {
    let _val = newValue
    if (newValue.isNew) {
      _val = _.find(options, opt => opt.name.toLowerCase() === newValue.name.toLowerCase())
    }
    _val = _.get(_val, 'id', newValue.name) // Fallback to persisting user input
    this.emitChange(_val)
  }

  handleListInputChange = (textBlocks, blockData) => {
    const sanitized = textBlocks.reduce((out, line) => {
      if (line.length) {
        out.push(line)
      }
      return out
    }, [])
    console.log('Input handleListInputChange', textBlocks, blockData)

    // const hasInvalidLines = _.some(blockData, d => d.invalid)
    // if (hasInvalidLines) {
    //   console.log('~~LIST input invalid lines')
    //   this.setState({
    //     invalidMsg: "Invalid list entries"
    //   })
    // }
    this.emitChange(sanitized)
  }

  /**
   * ListInput with ENUM style needs to re-map enum `name` strings back to raw values
   *
   * @memberof Input
   */
  handleEnumListInputChange = (textBlocks, blockData) => {
    const {
      schema,
      fieldName,
      field,
    } = this.props
    const enumOptions = schema.getFieldOptions(field)

    return this.handleListInputChange(
      textBlocks.map(row => {

      }),
      blockData
    )
  }

  handleClearClick = () => {
    this.handleInputChange("")
  }

  handleFocus = () => {
    const {onFocus} = this.props
    this.setState({
      hasFocus: true,
      hasSeenFocus: true
    })
    if (onFocus) {
      onFocus()
    }
  }

  _handleBlur = () => {
    const {onBlur} = this.props
    this.setState({
      hasFocus: false
    }, this._checkValidity)
    if (onBlur) {
      onBlur()
    }
  }

  renderInput = currentValue => {
    const {
      schema,
      fieldName,
      field,
      readOnly,
      customInputs
    } = this.props
    const {
      hasSeenFocus
    } = this.state
    const {
      display,
      editable,
      type,
      required
    } = field.toJS()
    const {
      validate,
      placeholder,
      maxAllowed,
      style
    } = editable
    // If explicitly false, bypass validation. Otherwise fall back to default by type
    // const _validate = validate === false ? null : !validate ? getDefaultValidate(type) : validate
    // console.log('Input validate?', validate)
    // console.log('renderInout...', type, maxAllowed)

    const commonClassNames = `` //${stealth ? 'stealth' : 'not_stealth'}`

    if (type === TYPES.LIST) {
      // monospace={itemType === TYPES.STRING ? false : true}
      const listItem = field.get('listItem')
      const listItemType = listItem.get('type')

      let listItemValidator = listItem.getIn(['editable', 'validate'])
      // let listItemOptions = listItem.get('options')
      let listItemOptions = listItem.has('options') && schema.getFieldOptions(listItem)
      let saveHandler = this.handleListInputChange
      console.log('render List Input', listItemOptions)
      const lineValidator = hasSeenFocus ? schema.validateField : null

      if (listItemType === TYPES.ENUM) {
        console.log('ENUM LIST', listItemOptions)

        // listItemValidator
        listItemOptions = listItemOptions.valueSeq().map(v => v.get('name')).toArray()
        console.log('list item options?', listItemOptions)

        // saveHandler = this.handleEnumListInputChange
      }
      // lineValidator={lineValidator}
      // lineValidatorArgs={[listItem, false]}

      return (
        <ListInput
          className={`schemer_list_input ${commonClassNames}`}
          id={`input_${fieldName}`}
          readOnly={readOnly}
          lineClassName={`schemer_list_input_line line_type_${listItemType.toLowerCase()}`}
          initialValue={(currentValue || []).join("\r\n")}
          typeaheadOptions={listItemOptions}
          allowFileUpload={false}
          onChange={this.handleListInputChange}
          saveOnChange
          maxLines={maxAllowed}
        />
      )
      // const itemType = field.get('itemType', 'STRING')

      // if (
      //   itemType === TYPES.SUBNET
      //   || itemType ===  TYPES.IP
      //   || itemType ===  TYPES.IP_V4
      //   || itemType ===  TYPES.IP_V6
      // ) {
      //   return (
      //     <IpListInput
      //       className={`schemer_list_input ${commonClassNames}`}
      //       id={`input_${fieldName}`}
      //       readOnly={readOnly}
      //       initialValue={(currentValue || []).join("\r\n")}
      //       allowFileUpload
      //       onChange={this.handleListInputChange}
      //       allowCIDR={}
      //       allowIp={}
      //       saveOnChange
      //     />
      //   )
      // }
      // else if (
      //   itemType === TYPES.DOMAIN
      // ) {
      //   return (
      //     <DomainListInput
      //       className={`schemer_list_input ${commonClassNames}`}
      //       id={`input_${fieldName}`}
      //       readOnly={readOnly}
      //       monospace={itemType === TYPES.STRING ? false : true}
      //       initialValue={(currentValue || []).join("\r\n")}
      //       allowFileUpload
      //       onChange={this.handleListInputChange}
      //       lineValidator={}
      //       saveOnChange
      //     />
      //   )
      // }
      // else {
      //   // Default fallback (also used for generic itemType=TYPES.STRING
      //   return (
      //     <ListInput
      //       className={`schemer_list_input ${commonClassNames}`}
      //       id={`input_${fieldName}`}
      //       readOnly={readOnly}
      //       monospace={itemType === TYPES.STRING ? false : true}
      //       initialValue={(currentValue || []).join("\r\n")}
      //       allowFileUpload
      //       onChange={this.handleListInputChange}
      //       saveOnChange
      //     />
      //   )
      // }
    }
    else if (type === TYPES.ENUM) {
      const _options = schema.getFieldOptionsJS(field)

      if (style === ENUM_STYLES.DROPDOWN) {
        // return (
        //   <div className="input_wrap">
        //     { maxAllowed === 1 ? (
        //       <TypeaheadInput
        //         initialValue={currentValue}
        //         className={`schemer_dropdown_typeahead_input`}
        //         omitCaret={false}
        //         menuClassName={`schemer_dropdown_menu`}
        //         inputClassName={`schemer_text_input`}
        //         onChange={this.handleEnumTypeaheadChange}
        //         onChangeArgs={[_options]}
        //         onMenuClose={this.handleBlur}
        //         onMenuOpen={this.handleFocus}
        //         options={_options}
        //         saveOnBlur
        //         clearOnSave={false}
        //         resetMenuOnSave={false}
        //         saveOnChange={false}
        //         valueProp="id"
        //         readOnly={readOnly}
        //         preventAutoSelect={false}
        //         swallowTab={false}
        //         placeholder={placeholder}
        //         saveEmptyStrings
        //         activeOptionId={currentValue}
        //         groupByHeadingText
        //       />
        //     ) : (
        //       <TagInput
        //         allTags={ _options }
        //         appliedTags={ currentValue }
        //         className={ `schemer_tag_input ${commonClassNames}` }
        //         commitTags={ this.handleTagInputChange }
        //         iconClass={``}
        //         loading={ false }
        //         readOnly={ readOnly }
        //         renderUnmatchedTags
        //         allowCreate={false}
        //         valueProp="id"
        //         preventAutoSelect={false}
        //         onOpen={this.handleFocus}
        //         onClose={this.handleBlur}
        //         swallowTab={false}
        //         fieldLabel={placeholder || `Choose ${display}`}
        //       />
        //     ) }
        //   </div>
        // )
        return (
          <div className="input_wrap">
            <TypeaheadInput
              initialValue={currentValue}
              className={`schemer_dropdown_typeahead_input`}
              omitCaret={false}
              menuClassName={`schemer_dropdown_menu`}
              inputClassName={`schemer_text_input`}
              onChange={this.handleEnumTypeaheadChange}
              onChangeArgs={[_options]}
              onMenuClose={this.handleBlur}
              onMenuOpen={this.handleFocus}
              options={_options}
              saveOnBlur
              clearOnSave={false}
              resetMenuOnSave={false}
              saveOnChange={false}
              valueProp="id"
              readOnly={readOnly}
              preventAutoSelect={false}
              swallowTab={false}
              placeholder={placeholder}
              saveEmptyStrings
              activeOptionId={currentValue}
              groupByHeadingText
            />
          </div>
        )
      }
      else if (style === ENUM_STYLES.TABS) {
        // TODO tabs list
        return (
          <div className="input_wrap">
            <div>TODO ENUM_STYLE option: {style}</div>
          </div>
        )
      }
      else if (style === ENUM_STYLES.LIST) {
        // TODO linear selection list
        return (
          <div className="input_wrap">
            <div>TODO ENUM_STYLE option: {style}</div>
          </div>
        )
      }
      else {
        return (
          <div className="input_wrap">
            <div>Invalid ENUM_STYLE option: {style}</div>
          </div>
        )
      }

    }
    else if (type === TYPES.TAGS) {
      const _options = schema.getFieldOptionsJS(field)

      return (
        <div className="input_wrap">
          <TagInput
            allTags={ _options }
            appliedTags={ currentValue }
            className={ `schemer_tag_input ${commonClassNames}` }
            commitTags={ this.handleTagInputChange }
            iconClass={``}
            loading={ false }
            readOnly={ readOnly }
            renderUnmatchedTags
            validateOnChange
            allowCreate
            valueProp="name"
            onOpen={this.handleFocus}
            onClose={this.handleBlur}
            swallowTab={false}
            fieldLabel={placeholder || `Add ${display}`}
          />
        </div>
      )
    }
    else if (type === TYPES.STRING_LONG) {
      return (
        <div className="input_wrap">
          <TextareaInput
            className={`schemer_textarea_input ${commonClassNames}`}
            initialValue={currentValue}
            onChange={this.handleInputChange}
            readOnly={readOnly}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            placeholder={placeholder}
          />
          <span className="type_watermark">&para;</span>
        </div>
      )
    }
    else if (
      type === TYPES.BYTES ||
      type === TYPES.BYTES_PER_SEC
    ) {
      console.warn('FIXME finish SIZE/RATE input (unit selection)')

      return [
        <div className="input_wrap" key="_wrap">
          <TextInput
            className={`schemer_text_input ${commonClassNames}`}
            id={`input_${fieldName}`}
            readOnly={readOnly}
            cancelOnEsc
            blurOnSave
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            initialValue={currentValue}
            onSave={this.debouncedHandleInputChange}
            trimOnSave={false}
            placeholder={placeholder}
          />
        </div>,
        <div className={`input_helper`} key="_suffix">
          <DropdownMenu
            label="Mb/s"
          >
            unit options
          </DropdownMenu>
        </div>
      ]
    }
    else if (
      type === TYPES.DATETIME ||
      type === TYPES.DAY ||
      type === TYPES.TIME
    ) {
      return (
        <div className="input_wrap">
          DATETIME INPUT
        </div>
      )
    }
    else if (type === TYPES.DURATION_MS) {
      return (
        <div className="input_wrap">DURATION INPUT</div>
      )
    }
    else if (type === TYPES.BOOL) {
      return (
        <div className="input_wrap">
          <OnOffSwitch
            className={`schemer_on_off_switch ${commonClassNames}`}
            onChange={this.handleInputChange}
            value={currentValue}
            readOnly={readOnly}
            onLabel={field.get('trueDisplay')}
            offLabel={field.get('falseDisplay')}
          />
        </div>
      )
    }
    else if (type === TYPES.CUSTOM) {
      if (customInputs && customInputs.has(fieldName)) {
        const rawCurrentValue = this._getRawCurrentValue()
        const CustomComponent = customInputs.get(fieldName)
        return (
          <div className={`input_wrap`}>
            <CustomComponent
              className={`schemer_custom_input ${commonClassNames}`}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              initialValue={rawCurrentValue}
              onChange={this.debouncedHandleInputChange}
              {...{
                maxAllowed,
                readOnly,
                placeholder,
                display,
                fieldName
              }}
            />
          </div>
        )
      }
      else {
        return (
          <div className="input_wrap">No customInput component found for field: {fieldName}</div>
        )
      }
    }
    else if (BASIC_INPUT_TYPES.includes(type)) {
      return (
        <div className="input_wrap">
          <TextInput
            className={`schemer_text_input ${commonClassNames}`}
            id={`input_${fieldName}`}
            readOnly={readOnly}
            blurOnSave={false}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            initialValue={currentValue}
            onSave={this.debouncedHandleInputChange}
            saveOnChange
            trimOnSave={false}
            placeholder={placeholder}
          />
        </div>
      )
    }
    else {
      return (
        <div className="input_wrap">
          <div>~~~~Unknown Input for field "{fieldName}" (type:{type})~~~~</div>
        </div>
      )
    }
  }

  render() {
    const {
      fieldName,
      field,
      className,
      style,
      readOnly,
      prefixIcon,
      renderDefaultPrefixIcons,
      // required,
      showLabel
    } = this.props
    const {
      invalidMsg,
      hasFocus,
      hasValue
    } = this.state
    const {
      editable,
      display,
      required,
      type
    } = field.toJS()
    if (!editable) {
      return null
    }
    const {
      helperText
    } = editable

    const _prefixIcon = prefixIcon || DEFAULT_PREFIX_ICONS[type]

    const currentValue = this._getCurrentValueJS()

    return (
      <div
        className={cx(
          `schemer_input`,
          `input_style_${readOnly ? 'read_only' : style.toLowerCase()}`,
          `input_type_${type.toLowerCase()}`,
          className,
          {
            invalid: !!invalidMsg,
            read_only: readOnly,
            has_focus: hasFocus,
            has_value: hasValue,
            is_required: required
          }
        )}
      >
        <div className="input_content">
          {showLabel &&
            <div className="label_wrap">
              <TextOverflow>
                <label htmlFor={`input_${fieldName}`}>{display || fieldName}</label>
              </TextOverflow>
              {required &&
                <span
                  className={`required_field`}
                  data-tooltip={`Required field`}
                />
              }
            </div>
          }
          <div className="input_row">
            {renderDefaultPrefixIcons && _prefixIcon &&
              <div className={`input_helper`}>
                <span className={`icon icon-${_prefixIcon}`} />
              </div>
            }
            {this.renderInput(currentValue)}
            {hasValue &&
              <button
                className="schemer_icon_btn input_clear_btn icon icon-close"
                data-tooltip={`Clear value`}
                onFocus={this.handleFocus}
                onBlur={this.handleBlur}
                onClick={this.handleClearClick}
                type="button"
              />
            }
          </div>
        </div>
        <div className="schemer_helper_text">
          {invalidMsg &&
            <span className="schemer_invalid_msg">
              {invalidMsg}
            </span>
          }
          {hasFocus && !invalidMsg && helperText &&
            <span className="">{helperText}</span>
          }
        </div>
      </div>
    )
  }
}